import feathersClient from '../../feathers-client';

const defaultFeaturePagination ={
	total:100,
	$skip:0,
	$limit:10,
};
const deafultFeaturePaginationFilter ={
	$skip:defaultFeaturePagination.$skip,
	$limit: defaultFeaturePagination.$limit
}
export default{
	state:{
		featureList:[],
		featureListPagination:defaultFeaturePagination,
		featureListPaginationFilter:deafultFeaturePaginationFilter,
		careSpecialityType:[],
	},
	getters:{
		serFeaturePage:(state) => {
			const {$limit, $skip} = state.featureListPagination;
			return $skip / $limit + 1;
		}
	},
	mutations:{
		SET_FEATURE_LIST:(state,data) => {state.featureList = data;},
		SET_FEATURE_LIST_PAGINATION:(state,data) => {state.featureListPagination = {...state.featureListPagination,...data};},
		SET_FEATURE_LIST_PAGINATION_FILTER:(state,data) => {state.featureListPaginationFilter = {...state.featureListPaginationFilter,...data};},
		SET_CARE_SPECIALITY_LIST:(state,data) => {state.careSpecialityType = data;}
	},
	actions:{
		setFeatureListPage:({commit,state},page)=>{
			const $skip =(page -1) * state.featureListPagination.$limit;
			commit('SET_FEATURE_LIST_PAGINATION',{ $skip })
			commit('SET_FEATURE_LIST_PAGINATION_FILTER', { $skip });
			
		},
		getStaffProfileConfiguration:async ({rootGetters}) => {
			const result = await feathersClient.service('/api/v3/staff-profile-review-configuration').find({
				query:{
					$role: rootGetters.currentUserRole
				}
			});
			return result.data
		},
		createStaffProfileConfiguration: async({rootGetters},data) => {
			const result = await feathersClient.service('/api/v3/staff-profile-review-configuration').create(data,{
				query:{
					$role: rootGetters.currentUserRole
				}
			});
			return result
		},
		updateStaffProfileConfiguration: async({rootGetters},data) => {
			const id= data.id;
			delete data.id;
			const result = await feathersClient.service('/api/v3/staff-profile-review-configuration').patch(id,data,{
				query:{
					$role: rootGetters.currentUserRole
				}
			});
			return result
		},
		getAppversion:async ({rootGetters},data) => {
			const result = await feathersClient.service('/api/v3/appbackendcompatibilities').find({
				query:{
					$sort:{createdAt:-1},
					$limit:25,
				}
			});
			return result.data
		},
		createNewFeartureIntroduction: async({rootGetters},data) => {
			const result = await feathersClient.service('/api/v3/new-feature-introduction-configuration').create(data,{
				query:{
					$role: rootGetters.currentUserRole
				}
			});
			return result
		},
		getNewFeatureList: async({rootGetters,commit},filter)=>{
			const result = await feathersClient.service('/api/v3/new-feature-introduction-configuration').find({
				query:{
					$role: rootGetters.currentUserRole,
					...filter,
				}
			});
			commit('SET_FEATURE_LIST',result.data);
			commit ('SET_FEATURE_LIST_PAGINATION',{total :result.total})
			return result.data
		},
		updateFeatureIntroduction: async({rootGetters},data)=>{
			const id= data.id;
			delete data.id
			const result = await feathersClient.service('/api/v3/new-feature-introduction-configuration').patch(id,data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return result;
		},
		getNewFeatureById: async({rootGetters},id) =>{
			const result = await feathersClient.service('/api/v3/new-feature-introduction-configuration').get(id,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return result
		},
		deleteNewFeatureById: async({rootGetters},id) => {
			const result = await feathersClient.service('/api/v3/new-feature-introduction-configuration').remove(id,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return result
		},
		getCareSpecialtityType: async({rootGetters,commit},filter) =>{
			const result = await feathersClient.service ('/api/v3/care-speciality-types').find({
				query:{
					fields:['mappings']
				}
			})
			commit('SET_CARE_SPECIALITY_LIST',result)
		},
		createCareSpecialityType:async({rootGetters},data)=>{
			const result = await feathersClient.service('/api/v3/care-speciality-types').create(data,{
				query:{
					$role: rootGetters.currentUserRole
				}
			});
			return result
		},
		updateCareSpecialityType:async({rootGetters},data) =>{
			const id= data.id;
			delete data.id
			const result = await feathersClient.service('/api/v3/care-speciality-types').patch(id,data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return result;
		},
		deleteCareSpecialityType:async({rootGetters},id) => {
			const result = await feathersClient.service('/api/v3/care-speciality-types').remove(id,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return result
		},
		getDraftedCheckListItem :async ({rootGetters, commit}, filter) => {
			const result = await feathersClient.service('/api/v3/drafted-shift-checklist-configuration').find({
				query: {
					$role: rootGetters.currentUserRole,
					...filter,
				},
			});
			commit('SET_FEATURE_LIST_PAGINATION', { total: result.total });
			return result?.data;
		},
		createDraftedCheckListItem :async ({rootGetters},data) => {
			const result = await feathersClient.service ('/api/v3/drafted-shift-checklist-configuration').create(data,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			})
			return result
		},
		updateDraftedCheckListItem :async ({rootGetters},data) => {
			const id= data.id;
			delete data.id
			const result = await feathersClient.service ('/api/v3/drafted-shift-checklist-configuration').patch(id,data,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			})
			return result
		},
		deleteDraftedCheckListItem :async ({rootGetters},id) => {
			const result = await feathersClient.service ('/api/v3/drafted-shift-checklist-configuration').remove(id,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			})
			return result
		},
	}

}
